import { ResourceView } from '@ra-data-prisma/dataprovider';
import { gql } from '@apollo/client';

export const Booking: ResourceView = {
  resource: 'Booking',
  fragment: {
    one: {
      type: 'document',
      mode: 'extend',
      doc: gql`
        fragment BookingFragment on Booking {
          bookingFuelPassword {
            id
            createdAt
          }
          bookingRefunding {
            id
            refunding
            createdAt
          }
          sharedVehicleGroup {
            id
            name
            discount
            ownerBehavior
            isPrivate
            deletedAt
          }
          user {
            id
            firstName
            lastName
            email
          }
          vehicleLocation {
            id
            latitude
            longitude
            name
          }
          sharedVehicleGroup {
            id
            name
            discount
            ownerBehavior
            isPrivate
            deletedAt
          }
          vehicle {
            id
            name
            brandType {
              id
              name
            }
            modelType {
              id
              name
            }
          }
        }
      `,
    },
    many: {
      type: 'document',
      mode: 'extend',
      doc: gql`
        fragment BookingFragment on Booking {
          vehicleLocation {
            id
            latitude
            longitude
            name
          }
          user {
            id
            firstName
            lastName
            email
          }
          bookingRefunding {
            id
            refunding
            createdAt
          }
          calculation {
            startPrice {
              totalCost
              insuranceCost
              excessKm
              lateFees
              costForDistance
              costForDuration
              totalCostWithoutInsurance
            }
            endPrice {
              totalCost
              insuranceCost
              excessKm
              lateFees
              costForDistance
              costForDuration
              totalCostWithoutInsurance
            }
          }
          vehicle {
            id
            vin
            plateNumber
            vehicleInsuranceType {
              id
              name
            }
            modelType {
              id
              name
            }
            name
            brandType {
              id
              name
            }
          }
        }
      `,
    },
  },
};
